import { z } from 'zod';

// https://docs.slace.com/docs/stoplight-docs-core/5b28c6c26ecad-segment
export const schemaSlaceSegment = z.object({
    contact_id: z.string().optional(),
    created_at: z.string().optional(),
    expires_at: z.string().optional(),
    key: z.string(),
    organzation_id: z.string().optional(),
    sub_type: z.enum(['default', 'location', 'campaign']),
    type: z.enum(['static', 'dynamic', 'key']).optional(),
    updated_at: z.string().optional(),
});

export type SchemaSlaceSegment = z.infer<typeof schemaSlaceSegment>;
